<template>
  <Switch
    v-model="enabledSwitch"
    :class="[
      enabled ? `bg-${activeColor}-500` : `bg-gray-over-dark`,
      smallToggle ? 'h-5 w-10' : 'h-6 w-11',
      disableYourOwnRoles ? 'cursor-not-allowed opacity-40' : 'cursor-pointer',
      'relative inline-flex flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none',
    ]"
  >
    <span
      :class="[
        enabled ? 'translate-x-5' : 'translate-x-0',
        smallToggle ? 'h-4 w-4' : 'h-5 w-5',
        'pointer-events-none relative inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
      ]"
    />
  </Switch>
</template>

<script>
import { Switch } from '@headlessui/vue';

export default {
  name: 'ToggleIcon',
  components: {
    Switch,
  },
  props: {
    bgClass: String,
    iconClass: String,
    activeColor: {
      type: String,
      default: 'yellow',
    },
    modelValue: {
      type: Boolean,
    },
    scope: String,
    id: Number,
    scopes: Array,
    smallToggle: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      enabled: this.modelValue,
    };
  },
  computed: {
    enabledSwitch: {
      get() {
        return this.enabled;
      },
      set(newValue) {
        if (
          this.id !== this.$store.state.users.currentUser.id ||
          this.$store.state.users.currentUser?.scopes?.includes('manage_users')
        ) {
          this.enabled = newValue;
        }
      },
    },
    textColorClass() {
      return 'text-' + this.activeColor + '-500';
    },
    disableYourOwnRoles() {
      if (
        this.id === this.$store.state.users.currentUser.id &&
        !this.$store.state.users.currentUser?.scopes?.includes('manage_users')
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    modelValue: function (newValue) {
      this.enabled = newValue;
    },
    enabled: async function (newValue) {
      this.$emit('update:modelValue', newValue);
      const data = {
        id: this.id,
        scopes: {
          user: {
            scopes: this.getGeneralScopes(newValue, this.scopes, this.scope),
          },
        },
      };
      await this.$store
        .dispatch('users/setScopes', data)
        .then(() => {
          if (newValue) {
            this.$toast.open({
              message: 'Permission added',
              position: 'top-right',
              duration: 2000,
            });
          } else {
            this.$toast.open({
              message: 'Permission removed',
              position: 'top-right',
              duration: 2000,
            });
          }
        })
        .catch((r) => {
          this.$toast.open({
            message: r.message,
            position: 'top-right',
            duration: 500,
          });
        });
      const body = {
        companyId: this.$store.state.users.currentUser.company.id,
        perPage: 50,
      };
      await this.$store.dispatch('users/getCompanyUsers', body);
    },
  },

  methods: {
    getGeneralScopes(isAdd, scopes, scopeToAddOrRemove) {
      let scopeAssigned = Object.assign([], scopes);
      if (isAdd) {
        scopeAssigned.push(scopeToAddOrRemove);
      } else {
        const isInTheArray = (scope) => scope === scopeToAddOrRemove;
        const index = scopeAssigned.findIndex(isInTheArray);
        scopeAssigned.splice(index, 1);
      }
      return scopeAssigned;
    },
  },
};
</script>
